<template>
  <div id="app">
    <v-app>
      <v-navigation-drawer
        v-if="loggedIn"
        width="50"
        app
        :value="getNavigationDrawerShow()"
        hide-overlay
        stateless
        class="primary darken-3 no-print"
        dark
      >
        <v-toolbar
          flat
          class="transparent mb-3"
        >
          <v-list class="pa-0">
            <v-list-tile avatar>
              <v-tooltip
                color="black"
                right
              >
                <v-menu
                  slot="activator"
                  v-model="userMenuIsOpen"
                  offset-x
                  :close-on-content-click="false"
                >
                  <v-list-tile-avatar slot="activator">
                    <v-badge
                      v-model="existenceUnreadedNotifications"
                      overlap
                      style="height: 40px; width: 40px;"
                    >
                      <template v-slot:badge>
                        <span>{{ unreadedNotifications.length }}</span>
                      </template>
                      <img :src="userAvatar">
                    </v-badge>
                  </v-list-tile-avatar>
                  <v-card width="400">
                    <v-layout row>
                      <v-flex xs-10>
                        <v-list>
                          <v-list-tile>
                            <v-list-tile-title>
                              {{ user.title ? user.title : user.name }}
                            </v-list-tile-title>
                          </v-list-tile>
                          <v-list-tile
                            v-for="role in user.roles"
                            :key="role.id"
                          >
                            <v-list-tile-sub-title>
                              {{ role.title }}
                            </v-list-tile-sub-title>
                          </v-list-tile>
                        </v-list>
                      </v-flex>
                      <v-flex
                        xs-2
                        class="pa-3 text-xs-center"
                      >
                        <v-badge
                          v-model="existenceUnreadedNotifications"
                          right
                        >
                          <template v-slot:badge>
                            <span>{{ unreadedNotifications.length }}</span>
                          </template>
                          <v-icon medium>
                            notifications
                          </v-icon>
                        </v-badge>
                      </v-flex>
                    </v-layout>

                    <v-divider v-if="notifications.length > 0" />
                    <NotificationsList
                      :items="notifications"
                      @change="changeNotificationState"
                    />
                    <v-divider />

                    <v-card-actions>
                      <v-spacer />

                      <v-btn
                        flat
                        small
                        @click="
                          $router.push({
                            name: 'user',
                            params: { id: user.id }
                          })
                        "
                      >
                        Профиль
                      </v-btn>
                      <v-btn
                        color="primary"
                        small
                        flat
                        @click="logout"
                      >
                        Выход
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
                <span>{{ user.title ? user.title : user.name }}</span>
              </v-tooltip>
              <v-list-tile-content>
                <v-list-tile-title>Admin</v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-btn
                  icon
                  @click.stop="mini = !mini"
                >
                  <v-icon>chevron_left</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-toolbar>

        <v-list
          class="pt-0"
          dense
        >
          <v-list-tile
            v-for="item in menu"
            :key="item.title"
            class="mb-3"
            @click="navigateTo(item)"
          >
            <v-tooltip
              color="black"
              right
            >
              <v-list-tile-action slot="activator">
                <v-icon large>
                  {{ item.icon }}
                </v-icon>
              </v-list-tile-action>
              <span>{{ item.title }}</span>
            </v-tooltip>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>

      <v-navigation-drawer
        v-if="loggedIn && navigatedMenuItem !== null"
        v-model="showSubMenu"
        fixed
        temporary
      >
        <v-toolbar
          class="primary darken-2 pl-2"
          flat
          dark
        >
          <v-list>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>{{ navigatedMenuItem.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-title class="title">
                {{ navigatedMenuItem.title }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-toolbar>

        <v-list class="pa-2">
          <div
            v-for="item in navigatedMenuItem.subItems"
            :key="item.title"
          >
            <v-list-tile
              v-if="item.route"
              :to="getRoutePath(item)"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider v-if="item.divider" />
          </div>
        </v-list>
      </v-navigation-drawer>

      <v-content
        v-if="loggedIn"
        class="grey lighten-2"
      >
        <v-container
          fluid
          class="pa-2"
        >
          <router-view
            :key="$route.fullPath"
            @changeUser="changeUser"
          />
          <NestedEditors />
        </v-container>
      </v-content>

      <v-content
        v-else
        class="grey lighten-2"
      >
        <v-container fluid>
          <SignIn @login="login" />
        </v-container>
      </v-content>

      <v-footer
        app
        class="primary darken-1"
        dark
        height="25"
        style="min-height: 25px; font-size: 12px"
      >
        <span class="px-2">&copy;2018-{{ currentYear }}</span>
      </v-footer>

      <v-snackbar
        v-model="errorSnackbar"
        color="error"
        right
      >
        {{ errorMessage }}
      </v-snackbar>

      <v-snackbar
        v-model="infoSnackbar"
        color="info"
        right
      >
        {{ infoMessage }}
      </v-snackbar>
    </v-app>
  </div>
</template>

<script>
import auth from "./auth.js";
import SignIn from "./components/SignIn.vue";
import NestedEditors from "./components/nested-editors/NestedEditors.vue";
import NotificationsList from "./components/notifications/NotificationsList.vue";
import { appMenu } from "./appMenu.js";
import { userRoles } from "./enums/user-roles.js";
import * as notifications from "./backend/notificationsApi.js";
export default {
  components: {
    SignIn,
    NestedEditors,
    NotificationsList,
  },
  data() {
    return {
      showSubMenu: false,
      errorSnackbar: false,
      errorMessage: "",
      infoSnackbar: false,
      infoMessage: "",
      items: [],
      menuItems: appMenu,
      navigatedMenuItem: null,
      user: null,
      userMenuIsOpen: false,
      notifications: [],
      lastUnreadedNotificationId: 0,
    };
  },
  computed: {
    menu() {
      if (!this.user.roles) {
        this.logout();
      }

      const isAdmin = this.user.roles.find(item => {
        return item.id == 0;
      });

      if (isAdmin) {
        return this.menuItems;
      } else {
        return this.menuItems
          .filter(
            i =>
              this.items.includes(i.route) ||
              (i.subItems &&
                i.subItems.filter(s => this.items.includes(s.route)).length),
          )
          .map(m => {
            return {
              title: m.title,
              icon: m.icon,
              route: m.route,
              subItems: m.subItems
                ? m.subItems
                  .filter(s => this.items.includes(s.route))
                  .map(i => {
                    return { ...i };
                  })
                : [],
            };
          });
      }
    },
    loggedIn() {
      return !!this.user;
    },
    currentYear() {
      return new Date().getFullYear();
    },
    userAvatar() {
      if (this.user.avatar) {
        return this.user.avatar;
      } else {
        // eslint-disable-next-line max-len
        return "data:image/jpeg;base64,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";
      }
    },
    unreadedNotifications() {
      return this.notifications.filter(n => {
        return n.isReaded === false;
      });
    },
    existenceUnreadedNotifications() {
      return this.unreadedNotifications.length > 0;
    },
  },
  watch: {
    userMenuIsOpen() {
      if (this.userMenuIsOpen) {
        this.getNotifications();
      }
    },
  },
  created() {
    if (auth.loggedIn()) {
      this.user = auth.getUser();
      this.getItems();
      this.getNotifications();
      // setInterval(() => {
      //   this.getNotifications();
      // }, 10000);
    }
  },
  methods: {
    getRoutePath(item) {
      if (this.user.roles.find(r => r.id === userRoles.Admin)) {
        return { name: item.route };
      } else {
        const catalogItems =
          this.navigatedMenuItem.title === "Справочники"
            ? this.navigatedMenuItem.subItems.map(i => i.route)
            : [];
        if (catalogItems.length && catalogItems.includes(item.route)) {
          return { name: item.route, params: { disabledDownload: true } };
        } else {
          return { name: item.route };
        }
      }
    },
    navigateTo(menuItem) {
      if (menuItem.subItems && menuItem.subItems.length > 0) {
        this.navigatedMenuItem = menuItem;
        this.showSubMenu = true;
      }
      if (
        (!menuItem.subItems || menuItem.subItems.length === 0) &&
        menuItem.route
      ) {
        this.$router.push({ name: menuItem.route });
      }
    },
    showError(message) {
      this.errorSnackbar = false;
      this.errorMessage = message;
      this.errorSnackbar = true;
    },
    showInfo(message) {
      this.infoSnackbar = false;
      this.infoMessage = message;
      this.infoSnackbar = true;
    },
    getNavigationDrawerShow() {
      if (this.$router.history.current.path === "/login") {
        return false;
      }
      return true;
    },
    logout() {
      location.reload();
      this.user = null;
      this.items = [];
      auth.logout();
    },
    login() {
      this.user = auth.getUser();
      this.getItems();
    },
    changeUser() {
      this.user = auth.getUser();
    },
    getItems() {
      this.$http.get("users/permissions").then(res => {
        if (!res.data.length) {
          this.logout();
          return;
        }
        this.items = res.data;
        localStorage.userPermissions = res.data;
      });
    },
    async getNotifications() {
      this.notifications = await notifications.getNotifications();
      if (!this.unreadedNotifications.length) {
        return;
      }
      if (
        this.unreadedNotifications.slice(-1)[0].id !==
        this.lastUnreadedNotificationId
      ) {
        this.showInfo(
          this.unreadedNotifications.slice(-1)[0].message ||
            "Есть непрочитанные уведомления",
        );
        this.lastUnreadedNotificationId = this.unreadedNotifications.slice(
          -1,
        )[0].Id;
      }
    },
    async changeNotificationState(notification) {
      await notifications.changeNotificationState(notification);
    },
  },
};
</script>

<style>
#get-file-dialog {
  display: none;
}
.v-list .v-list__tile {
  padding: 0 6px;
}
table.v-table thead th,
table.v-table tbody td {
  padding: 0 5px !important;
}
table.v-table thead tr:first-child {
  height: 35px !important;
}
table.v-table tbody td,
table.v-table tbody th {
  height: 35px !important;
}
table.v-table {
  line-height: 1.3;
}
.v-btn.plus-button {
  width: 25px;
  height: 25px;
  min-width: 25px;
  min-height: 25px;
}
html .v-input {
  font-size: 14px;
}
.v-input .v-label {
  font-size: 14px;
}
.v-input .v-icon {
  font-size: 19px;
}
.table-striped tr,
th {
  background: #ffffff;
}
.table-striped tr:nth-child(even) {
  background: #ffffff;
}
.table-striped tr:nth-child(odd) {
  background: #f5f5f5;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: #d4d4d4;
}

::-webkit-scrollbar-thumb {
  background: #939393;
  border-radius: 8px;
  border: 3px solid #d4d4d4;
}
.v-text-field--outline > .v-input__control > .v-input__slot {
  min-height: auto !important;
}
.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
  border: 1px solid rgba(0, 0, 0, 0.54) !important;
}
.v-text-field--outline .v-label {
  top: 10px !important;
}
.v-text-field--outline input {
  padding: 4px 0 !important;
}
.v-text-field--outline .v-select__selections {
  padding-top: 18px !important;
}
.list {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list-title:hover {
  background: #eeeeee;
  cursor: pointer;
}
.v-badge__badge {
  right: -10px !important;
}
.autofill-chip-small .v-chip--small {
  height: 20px !important;
}
.v-text-field.v-text-field--enclosed .v-input__prepend-inner {
  margin-top: 6px !important;
}
.v-data-table--fixed-header {
  height: 93%;
  width: 100%;
}
.v-data-table--fixed-header .v-table__overflow {
  overflow-y: auto;
  height: 100%;
  width: 100%;
}
.v-data-table--fixed-header thead th {
  border-bottom: 0 !important;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2;
}
.v-data-table--fixed-footer tfoot td {
  border-bottom: 0 !important;
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  z-index: 2;
}
.footer-table-cell {
  background: #fff;
  font-weight: bold;
}
.link {
  text-decoration: underline;
  color: #1976d2;
  cursor: pointer;
}
.label-title {
  white-space: nowrap;
  overflow: unset;
}
.default-cursor {
  cursor: default;
}
.clickable-row {
  cursor: pointer;
}
.not-allowed {
  cursor: not-allowed;
}

@media print {
  .no-print {
    display: none !important;
  }
  .print {
    display: block !important;
  }
  tr,
  li,
  p {
    page-break-inside: avoid;
  }
}
</style>
